<div id="c-landing-site-page" class="c-landing" *ngIf="isLoaded">
  <custom-page [pageId]="this.pageId" [networkId]="this.network"></custom-page>
</div>
